// extracted by mini-css-extract-plugin
export default {"text":"ExVfnEG9_SQTBIwE40lQ"};